module.exports = __webpack_public_path__ + "static/media/_Start.3d5524e6.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/Start/_Start.scss
// module id = 315
// module chunks = 0